import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, StylesProvider, ThemeProvider } from '@material-ui/core';
import { ThemeProvider as ScThemeProvider } from 'styled-components';

import { i18next } from 'locale/i18n';
import { MUI_THEME } from 'theme';
import { ScrollToTop } from 'common/components/ScrollToTop';
import { SnackbarContextProvider } from 'common/context';

import { client } from './graphql/client';
import { App } from './App';
import { GlobalStyle } from './GlobalStyle';

const renderApp = () => {
    ReactDOM.render(
        <BrowserRouter>
            <ApolloProvider client={client}>
                <GlobalStyle />
                <StylesProvider injectFirst>
                    <ScThemeProvider theme={MUI_THEME}>
                        <ThemeProvider theme={MUI_THEME}>
                            <ScrollToTop />
                            <CssBaseline />
                            <SnackbarContextProvider>
                                <App />
                            </SnackbarContextProvider>
                        </ThemeProvider>
                    </ScThemeProvider>
                </StylesProvider>
            </ApolloProvider>
        </BrowserRouter>,
        document.getElementById('root')
    );
};

i18next.then(renderApp);
